// import {
//   getCodeUrl,
//   validateIsRegUrl
// } from '@/api';
// import {
//   protocol_url
// } from '@/js/global.js';
// 验证是否注册
export function validateIsRegister(phone) {
  const tnt = $.Deferred();
  $.ajax({
    url: `${validateIsRegUrl}/${phone}`,
    contentType: 'application/json;charset=UTF-8',
  }).then(res => {
    tnt.resolve(res);
  }, error => {
    tnt.reject(error);
    });
  return tnt.promise();
};
// 获取验证码
export function getSmsCode(data) {
  const tnt = $.Deferred();
  $.ajax({
    url: `${getCodeUrl}/${data.phone}/${data.type}`,
    contentType: 'application/json;charset=UTF-8',
  }).then(res => {
    tnt.resolve(res);
  }, error => {
    tnt.reject(error);
  });
  return tnt.promise();
};

// 去除空字符
export function trimAll(string) {
  return (string = String(string)).replace(/\s*/g, '');
}
// 显示错误信息
export function showError(text = '', id = '_error_') {
  const ele = document.getElementById(id);
  ele.innerText = text;
  text && (ele.focus());
};
export function showError1(text = '', id = '_error1_') {
  const ele = document.getElementById(id);
  ele.innerText = text;
  text && (ele.focus());
};
// 显示错误input
export function addErrorClass(id, is = !1) {
  is ? ($(`#${id}`).addClass('error')) : ($(`#${id}`).removeClass('error'))
};
// 查看协议
export function watchProtocol(id = 'protocol') {
  document.getElementById(`${id}`).addEventListener('click', function () {
    window.open(protocol_url);
  })
};
// 发送事件
export function emitEvent(message = '请求成功') {
  const evt = new CustomEvent('showMessage', {
    detail: message
  });
  if (window.dispatchEvent) {
    window.dispatchEvent(evt)
  } else {
    window.fireEvent(evt);
  }
};

// 时间重构
export function timeRebuild(timestamp, format = 'yyyy-MM-dd hh:mm:ss') {
  if(!timestamp){
    return '-'
  }
  let date = new Date(timestamp);
  let o = {
    'y+': date.getFullYear(),
    'M+': date.getMonth() + 1, // 月份 "d+": value.getDate(), // 日
    'd+': date.getDate(),
    'h+': date.getHours(), // 小时 "m+": value.getMinutes(), // 分 "s+": value.getSeconds(), // 秒
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
    }
  }
  return format;
}

// 价格重构
export function priceRebuild(price, currency) {
  if(!price){
    return ''
  }
  const num = Number(price);
  const newPrice = (num / 100).toFixed(2);
  if(currency){
    return currency + newPrice
  }
  return newPrice
}

